import { ChevronRightIcon } from 'lucide-react-native';
import React from 'react';
import { View } from 'react-native';
import { ListItem } from '../../Core/List/ListItem';
import { IconProps } from '../../Icons/Icons.types';

export type ProductListItemType = {
  iconComponent: React.ElementType;
  iconProps?: IconProps;
  assetColumn?: React.ReactNode;
  priceColumn?: React.ReactNode;
  percentageChangeColumn?: React.ReactNode;
  //on mobile we will use this one for the right end column
  actionsColumn?: React.ReactNode;
  isPressable?: boolean;
  onPress?: () => void;
  isMobile?: boolean;
  className?: string;
  showChevron: boolean;
};

export const ProductListItem = ({
  iconComponent: IconComponent,
  iconProps,
  assetColumn,
  priceColumn,
  percentageChangeColumn,
  actionsColumn,
  isPressable,
  onPress,
  isMobile,
  className,
  showChevron = false
}: ProductListItemType) => {
  return (
    <ListItem
      onPress={() => onPress?.()}
      className={className}
      pressable={isPressable ?? onPress !== undefined}>
      {isMobile ? (
        <View className="w-full flex-row">
          <View className="w-1/2 flex-row justify-start gap-4 items-center">
            <IconComponent {...iconProps} width={30} />
            {assetColumn}
          </View>
          <View className="w-1/2">{actionsColumn}</View>
        </View>
      ) : (
        <View className="w-full flex-row">
          <View className="w-1/2 flex-row justify-start gap-4 items-center">
            <IconComponent {...iconProps} width={30} />
            {assetColumn}
          </View>
          <View className="w-1/2 grid grid-cols-3 gap-4">
            <View className="flex items-end justify-center">{priceColumn}</View>
            <View className="flex items-end justify-center">
              {percentageChangeColumn}
            </View>
            <View className="flex-row items-center justify-end gap-4">
              {actionsColumn}
              {showChevron && <ChevronRightIcon className="text-white flex-shrink-0" />}
            </View>
          </View>
        </View>
      )}
    </ListItem>
  );
};
